var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative z-10 bg-bg_gray"},[_c('VideoCarousel'),_c('About'),_c('PoliticsList'),_c('ImageGallery'),_c('AreaPolitics'),_c('Service')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }